var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdsTimeSlot01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 0.75px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ads time slot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.75,
    y: 2.65,
    width: 19.75,
    height: 19.75,
    rx: 3.63
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.3,
    y1: 1.1,
    x2: 8.3,
    y2: 5.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.95,
    y1: 1.1,
    x2: 16.95,
    y2: 5.42
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.63,
    cy: 13.45,
    r: 5.55
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "12.24 10.36 12.24 14.06 15.32 14.06"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsTimeSlot01);
export default __webpack_public_path__ + "static/media/ads_time_slot_01.ce256522266a30e4855dcdb8290c9d3b.svg";
export { ForwardRef as ReactComponent };